import React, { useState } from 'react';
import {
  ChakraProvider,
  theme,
} from '@chakra-ui/react';


import { AppRouter } from './router/AppRouter';
import { LoginContext } from './context/LoginContext';


function App() {
  const [user, setUser] = useState({})

  return (
    <LoginContext.Provider value={{ setUser, user }} t>
      <ChakraProvider theme={theme}>
        <AppRouter />
      </ChakraProvider>
    </LoginContext.Provider>
  );
}

export default App;
